import BlogPostCard from '../BlogPostCard'
import { BlogPostType } from '../BlogPostCard/BlogPostCardTypes'

import { HeroWrapper, Inner, Latest, Main, Tile } from './HomePageHeroShards'

interface Props {
  main: BlogPostType
  latest: BlogPostType[]
}

const HomePageHeroView: React.FC<Props> = ({ main, latest }) => {
  return (
    <HeroWrapper>
      <Inner>
        <Main>
          <BlogPostCard post={main} type='main' />
        </Main>
        <Latest>
          {latest.map((post, i) => (
            <Tile key={i}>
              <BlogPostCard post={post} isHorizontal />
            </Tile>
          ))}
        </Latest>
      </Inner>
    </HeroWrapper>
  )
}

export default HomePageHeroView
